module.exports = __webpack_public_path__ + "src/assets/animations/wasp.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animations/wasp.png
// module id = ./src/assets/animations/wasp.png
// module chunks = 0